export const governances = [
    {
        name: "Polsek Agrabinta",
        position: [-7.4087873363999375, 106.98585569858552],
        icon: 'police-station',
    },
    {
        name: "Kantor Kecamatan Agrabinta",
        position: [-7.417676352836582, 106.89955830574037],
        icon: 'government-building',
    },
    {
        name: "Kantor Kepala Desa Mekarsari",
        position: [-7.41909666378784, 106.90396785736085],
        icon: 'government-building',
    },
    {
        name: "PTPN VIII Agrabinta",
        position: [-7.40781384255209, 106.99205160140993],
        icon: 'factory',
    },
    {
        name: "Bank BRI Cabang Agrabinta",
        position: [-7.408239413897698, 106.98463797569276],
        icon: 'bank',
    },
];